<template>
  <commodity-qty-general
    :Analytics="Analytics"
    :colorTheme="colorTheme"
    :loadingAll="loadingAll"
    :processData="processData"
    :renderChartSignal="renderChartSignal"
    :idChart="idChart"
    :dataNest="dataNest"
    :asset="asset"
    @onTableFormat="onHoverChart"
    @changeInfoTable="changeInfoTable"
  />
</template>

<script>
import CommodityQtyGeneral from "./CommodityQtyGeneral.vue";
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";

export default {
  components: { CommodityQtyGeneral },
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics()
    },
    colorTheme: { required: true, type: Boolean, default: true },
    loadingAll: { required: true, type: Boolean, default: false },
    processData: { required: true },
    renderChartSignal: { required: true, default: 0 },
    asset: { required: false, default: "commodity" }
  },
  data() {
    return {
      idChart: "clients",
      dataNest: "clients"
    };
  },
  methods: {
    onHoverChart(val) {
      this.$emit("onTableFormat", val);
    },
    changeInfoTable(val) {
      this.$emit("changeInfoTable", val);
    }
  }
};
</script>
